let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6aFSl")).then(() => parcelRequire('2dRbb'));